export const FUNCTION_NOT_AVAILABLE_MSG = 'Diese Funktion ist für das ausgewählte Depot nicht verfügbar.';